import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import Breadcrumb from "Components/Common/Breadcrumb";
import { useTranslation } from "react-i18next";
import { Form, useNavigate } from "react-router-dom";
import { setAuthorization } from "../../helpers/api_helper";
import { useDispatch } from "react-redux";
import { fetchUsersInfo } from "slices/thunk";
import * as Yup from "yup";
import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "Components/Common/ChartDynamicColor";
import { useFormik } from "formik";
import AccountsOverview from "Components/Common/GraficHistoricalBalance";
import { decryptState } from "shared/encryptInfo";

const Spinearea = ({ dataColors }: any) => {
  const spineareaChartColors = getChartColorsArray(dataColors);

  const series = [
    {
      name: "USDC",
      data: [0, 0, 0, 0, 0, 0, 0],
    },
    {
      name: "BTC",
      data: [0, 0, 0, 0, 0, 0, 0],
    },
    {
      name: "USD",
      data: [0, 0, 0, 0, 0, 0, 0],
    },
  ];

  const options: any = {
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 3,
    },

    colors: spineareaChartColors,
    xaxis: {
      type: "datetime",
      categories: [
        "2018-09-19T00:00:00",
        "2018-09-19T01:30:00",
        "2018-09-19T02:30:00",
        "2018-09-19T03:30:00",
        "2018-09-19T04:30:00",
        "2018-09-19T05:30:00",
        "2018-09-19T06:30:00",
      ],
    },
    grid: {
      borderColor: "#f1f1f1",
    },
    tooltip: {
      x: {
        format: "dd/MM/yy HH:mm",
      },
    },
  };

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="area"
      height="250"
    />
  );
};

// Este componente se encarga de renderizar el contenido de la página de Dashboard
const Dashboard = (props: any) => {
  document.title = "Ditobanx";

  const navigate = useNavigate();

  const { t } = useTranslation();

  const handleNavigation = (path: any) => {
    navigate(`/${path}`);
  };

  const dispatch = useDispatch<any>();

  useEffect(() => {
    async function getData() {
      const token = localStorage.getItem("authUser");
      if (!token) {
        navigate("/login");
        return;
      }
      const nose = localStorage.getItem("userInfo");
      const id_user = decryptState(nose || "{}");
      // console.log("User Info:", id_user.id);
      setAuthorization(token); // Guardar el token antes de continuar
      try {
        dispatch(fetchUsersInfo(id_user.id));
      } catch (error) {
        console.log("Error fetching user data", error);
      }
    }
    getData();
  }, [dispatch]);

  //meta title
  document.title = "Accounts";
  const FlatPickr: React.ComponentType<any> =
    require("react-flatpickr").default;

  const [modal, setModal] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);

  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      orderId: "",
      billingName: "",
      orderDate: "",
      total: "",
      paymentStatus: "",
      badgeClass: "success",
      paymentMethod: "",
    },
    validationSchema: Yup.object({
      orderId: Yup.string().required("Please Enter Your Order Id"),
      billingName: Yup.string().required("Please Enter Your Billing Name"),
      orderDate: Yup.string().required("Please Enter Your Order Date"),
      total: Yup.string().required("Total Amount"),
      paymentStatus: Yup.string().required("Please Enter Your Payment Status"),
      badgeClass: Yup.string().required("Please Enter Your Badge Class"),
      paymentMethod: Yup.string().required("Please Enter Your Payment Method"),
    }),
    onSubmit: (values: any) => {
      // save new order
      validation.resetForm();

      toggle();
    },
  });

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
    } else {
      setModal(true);
    }
  }, [modal]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Dashboards" breadcrumbItem="Dashboards" />
          {/* <div className="col">
            <div
              className="card text-center"
              style={{
                ...styles.card,
                backgroundColor: " #7ba6de ",
              }}
              onClick={() => handleNavigation("Accounts")}
            >
              <div className="card-body">
                <h5 className="card-title" style={{ marginBottom: "0px" }}>
                  {t("Accounts")}
                </h5>
              </div>
            </div>
          </div> */}
          {/* <div className="row">
          <div className="col">
            <div
              className="card text-center"
              style={{
                ...styles.card,
                backgroundColor: " #7ba6de ",
              }}
              onClick={() => handleNavigation("Accounts")}
            >
              <div className="card-body">
                <h5 className="card-title" style={{ marginBottom: "0px" }}>
                  {t("Accounts")}
                </h5>
              </div>
            </div>
          </div>
            <div className="col">
              <div
                className="card text-center"
                style={{
                  ...styles.card,
                  backgroundColor: "rgb(143, 177, 177) ",
                }}
                onClick={() => handleNavigation("Acquisition")}
              >
                <div className="card-body">
                  <h5 className="card-title" style={{ marginBottom: "0px" }}>
                    {t("Acquisition")}
                  </h5>
                </div>
              </div>
            </div>
            <div className="col">
              <div
                className="card text-center"
                style={{
                  ...styles.card,
                  backgroundColor: " #fc9578 ",
                }}
                onClick={() => handleNavigation("dashboard-cards")}
              >
                <div className="card-body">
                  <h5 className="card-title" style={{ marginBottom: "0px" }}>
                    {t("Cards")}
                  </h5>
                </div>
              </div>
            </div>
          </div> */}
          <Card>
            <div className="d-flex justify-content-end mt-3 mb-3 gap-3">
              {/* <div>
          </div> */}
              {/* <button
                className="btn btn-secondary"
                style={{ marginRight: "30px" }}
                onClick={() => {
                  setModal(true);
                }}
              >
                Add Account
              </button> */}
              {/* <button className="btn btn-danger ">Money Account</button> */}
            </div>
            <div>
              <AccountsOverview />
            </div>
          </Card>
          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? "Edit Order" : "Add Order"}
            </ModalHeader>
            <ModalBody>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <Row>
                  <Col xs={12}>
                    <div className="mb-3">
                      <Label>Account Name</Label>
                      <Input
                        name="orderId"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.orderId || ""}
                        invalid={
                          validation.touched.orderId &&
                          validation.errors.orderId
                            ? true
                            : false
                        }
                      />
                      {validation.touched.orderId &&
                      validation.errors.orderId ? (
                        <FormFeedback type="invalid">
                          {validation.errors.orderId}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label>Billing Name</Label>
                      <Input
                        name="billingName"
                        type="text"
                        validate={{
                          required: { value: true },
                        }}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.billingName || ""}
                        invalid={
                          validation.touched.billingName &&
                          validation.errors.billingName
                            ? true
                            : false
                        }
                      />
                      {validation.touched.billingName &&
                      validation.errors.billingName ? (
                        <FormFeedback type="invalid">
                          {validation.errors.billingName}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label>Order Date</Label>
                      <FlatPickr
                        className="form-control d-block"
                        id="orderDate"
                        name="orderDate"
                        placeholder="Select date"
                        options={{
                          mode: "single",
                          dateFormat: "d M, Y",
                        }}
                        onChange={(kycBirthDate: any) =>
                          validation.setFieldValue()
                        }
                        value={validation.values.orderDate || ""}
                      />
                      {validation.touched.orderDate &&
                      validation.errors.orderDate ? (
                        <span className="text-danger">
                          {validation.errors.orderDate}
                        </span>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label>Total</Label>
                      <Input
                        name="total"
                        type="number"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.total || ""}
                        invalid={
                          validation.touched.total && validation.errors.total
                            ? true
                            : false
                        }
                      />
                      {validation.touched.total && validation.errors.total ? (
                        <FormFeedback type="invalid">
                          {validation.errors.total}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label>Total</Label>
                      <Input
                        name="paymentStatus"
                        type="select"
                        className="form-select"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.paymentStatus || ""}
                      >
                        <option>Paid</option>
                        <option>Chargeback</option>
                        <option>Refund</option>
                      </Input>
                      {validation.touched.paymentStatus &&
                      validation.errors.paymentStatus ? (
                        <FormFeedback type="invalid" className="d-block">
                          {validation.errors.paymentStatus}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label>Payment Method</Label>
                      <Input
                        name="paymentMethod"
                        type="select"
                        className="form-select"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.paymentMethod || ""}
                      >
                        <option>Mastercard</option>
                        <option>Visa</option>
                        <option>Paypal</option>
                        <option>COD</option>
                      </Input>
                      {validation.touched.paymentMethod &&
                      validation.errors.paymentMethod ? (
                        <FormFeedback type="invalid" className="d-block">
                          {validation.errors.paymentMethod}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="text-end">
                      <Button
                        type="submit"
                        color="success"
                        className="save-user"
                      >
                        {!!isEdit ? "Update" : "Add"}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};

const styles = {
  card: {
    color: "black",
    width: 18 + "rem",
    padding: 20 + "px",
    cursor: "pointer", // Add this property
  },
};

export default Dashboard;
